import { createColumnHelper } from '@tanstack/react-table';

import { ContainerListViewModel } from '../../../types';

export const columnHelper = createColumnHelper<ContainerListViewModel>();
